// =====================

import React, { ReactNode } from 'react';
import Uploader from '@/components/common/Uploader';
import Button from '@/components/common/Button';
import UploadedGalleryItems from '@/components/common/UploadedGalleryItems';
import styles from './styles.module.css';
import { UploadType } from '@/commonTypes';

interface AppUploadProps {
  state: any[];
  onUploadComplete: (data: any) => void;
  callBackDeleteItem: (item: any) => void;
  modalKey: string;
  title?: string;
  guide?: string;
  buttonText?: string;
  showError?: boolean;
  error?: string;
  uploadType?: UploadType;
  vertical?: boolean;
  uploadButton?: ReactNode | string;
  cropMode?: boolean;
  UploadButtonStyle?: string;
  enableDragAndDrop?: boolean;
  buttonContainerClassName?: string;
}

export default function AppUpload({
  state,
  onUploadComplete,
  callBackDeleteItem,
  modalKey,
  title = 'آپلود عکس ',
  guide = 'guide uload',
  buttonText = 'آپلود',
  showError = false,
  error = 'تصویر الزامی است',
  uploadType = 'image',
  vertical = true,
  uploadButton,
  cropMode = false,
  UploadButtonStyle = '',
  enableDragAndDrop = false,
  buttonContainerClassName = '',
}: AppUploadProps) {
  console.log('showError==', showError, enableDragAndDrop);

  return (
    <div className={styles.galleryWrapper}>
      <Uploader
        vertical={vertical}
        id="uploadImage"
        headTitle={title}
        showImg
        onUploadComplete={(data) => onUploadComplete(data)}
        uploadType={uploadType}
        buttonText={buttonText}
        uploadButton={
          uploadButton ? (
            uploadButton
          ) : (
            <Button className={`secondButton ${styles.uploadButton}`}>{buttonText}</Button>
          )
        }
        modalKey={modalKey}
        // guide={guide}
        cropMode={cropMode}
        UploadButtonStyle={UploadButtonStyle}
        enableDragAndDrop={enableDragAndDrop}
        buttonContainerClassName={buttonContainerClassName}
        error={error}
        showError={showError}
      />

      {state && state.length !== 0 && (
        <UploadedGalleryItems
          // uploadType={uploadType}
          images={state}
          callBackDeleteItem={(item) => callBackDeleteItem(item)}
        />
      )}

      {/* {showError && <p className={`inputErrorText`}>{error}</p>} */}
    </div>
  );
}
